<template>
  <v-container>
    <v-row
      style="display: flex; flex-direction: column"
      @keydown.esc="cancel()"
    >
      <Header :items="items"
        ><template slot="title">
          {{ $tc("newController.accessControl") }}
        </template></Header
      >
      <v-col>
        <DataTable
          :itemsPerPage="5"
          :headers="headers"
          :items="getAccessControl"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Header from "./common/Header.vue";
import DataTable from "./common/DataTable.vue";
import accessControl from "../../../store/gestionTiempos/accessControl";
export default {
  components: { Header, DataTable },
  props: {
    items: Object,
  },
  data() {
    return {
      headers: [
        {
          text: "Fecha",
          value: "date",
          class: "primary secondary--text",
          sortable: true,
        },
        {
          text: "Evento",
          value: "event",
          class: "primary secondary--text",
          sortable: true,
        },
        {
          text: "Descripción",
          value: "eventDescript",
          class: "primary secondary--text",
          sortable: true,
        },
        {
          text: "PCA",
          value: "pca",
          class: "primary secondary--text",
          sortable: true,
        },
        {
          text: "DFI",
          value: "dfiAlias",
          class: "primary secondary--text",
          sortable: true,
        },
        {
          text: "Tarjeta",
          value: "card",
          class: "primary secondary--text",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    getAccessControl() {
      return accessControl.state.accessControl.item;
    },
    cancel() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
